import { HELPER_BASE } from "@/consts.js";

const globalModule = {
  state: {
    loading: false,
    wizardLoading: false,
    helper_props: {},
    helper_comp: null,
    helper_base_url: HELPER_BASE,
    feature_flags: {},
    feature_flags_state: false,
    sub_header_margin_multiplier: true,
    csis_state: {
      isWorkingHour: true,
      officeHours: "7:00AM - 6:00PM PT (Mon-Fri)",
      phoneNumber: "+1 (866) 384-9104",
      isOpen: true,
      officeClosed: false,
      isHoliday: false,
      isWhatsAppAvailable: true,
      hideWhatsAppNumber: false,
      whatsappLink: "https://wa.me/16692242664?text=Hi%20there",
      phoneDownMessage: null,
      displayPhoneDown: false,
      chatbotEnabled: false,
      headerChatbotEnabled: false,
      chatbotScriptSRC: null,
    },
    chatbotVisible: true,
    chatbotForcedRoute: false,
    dropdown_options: {
      disableOverflow: false,
      disableScrollBack: false,
    },
    main_config_data: null,
    main_config_failure: false,
    app_new_version_info: null,
    app_features: {},
    app_features_variant: {},
    app_save_features_email: null,
    deviceInfo: {
      isMobileX: null,
      isTabletX: null,
      isDesktopX: null,
    },
    previousRoute: [],
    chatbot_options: {
      elements_to_watch: [],
      last_manual_adjust: 0,
    },
    header_buttons_toggle: {
      get_quotes: true,
      my_policy: true,
    },
    chatBoxHideRoot: false,
    all_destinations_popup: {
      destinations: null,
    },
  },
  getters: {
    loading: (state) => state.loading,
    wizardLoading: (state) => state.wizardLoading,
    helper_base_url: (state) => state.helper_base_url,
    helper_props: (state) => state.helper_props,
    helper_comp: (state) => state.helper_comp,
    feature_flags: (state) => state.feature_flags,
    feature_flags_state: (state) => state.feature_flags,
    sub_header_margin_multiplier: (state) => state.sub_header_margin_multiplier,
    csis_state: (state) => state.csis_state,
    global_dropdown_opts: (state) => state.dropdown_options,
    main_config_data: (state) => state.main_config_data,
    main_config_failure: (state) => state.main_config_failure,
    app_new_version_info: (state) => state.app_new_version_info,
    chatbotVisible: (state) => state.chatbotVisible,
    app_features: (state) => state.app_features,
    app_save_features_email: (state) => state.app_save_features_email,
    app_flags: (state) => state.app_features?.flags,
    app_flags_local: (state) => state.app_features?.flags_local == true,
    deviceInfo: (state) => state.deviceInfo,
    previousRoute: (state) => state.previousRoute,
    chatbot_option_watched_elements: (state) =>
      state.chatbot_options.elements_to_watch,
    chatbot_option_last_manual_adjust: (state) =>
      state.chatbot_options.last_manual_adjust,
    chatbotForcedRoute: (state) => state.chatbotForcedRoute,
    header_buttons_get_quote_toggle: (state) =>
      state.header_buttons_toggle.get_quotes,
    header_buttons_my_policy_toggle: (state) =>
      state.header_buttons_toggle.my_policy,
    chatBoxHideRoot: (state) => state.chatBoxHideRoot,
    app_features_variant: (state) => state.app_features_variant,
    get_all_destinations_list: (state) =>
      state.all_destinations_popup.destinations,
  },
  mutations: {
    loading_set(state, payload) {
      state.loading = payload;
    },
    wizard_loading_set(state, loading) {
      state.wizardLoading = loading;
    },
    helper_props_set(state, payload) {
      state.helper_props = payload;
    },
    helper_comp_set(state, payload) {
      state.helper_comp = payload;
    },
    feature_flags_set(state, payload) {
      state.feature_flags = payload;
    },
    feature_flags_state_set(state, payload) {
      state.feature_flags_state = payload;
    },
    sub_header_margin_multiplier(state, payload) {
      state.sub_header_margin_multiplier = payload;
    },
    set_csis_state(state, payload) {
      state.csis_state = payload;
    },
    global_dropdown_set_options(state, options) {
      state.dropdown_options = options;
    },
    set_main_config_data(state, data) {
      state.main_config_data = data;
    },
    set_main_config_failure(state, status) {
      state.main_config_failure = status ? true : false;
    },
    app_new_version_info_set(state, value) {
      state.app_new_version_info = value;
    },
    chatbotVisible_set(state, visible) {
      state.chatbotVisible = visible;
    },
    app_features_set(state, v) {
      state.app_features = v;
    },
    app_features_variant_set(state, v) {
      const clone = Object.assign({}, state.app_features_variant);
      clone[v.flag] = v.value;
      state.app_features_variant = clone;
    },
    app_save_features_email(state, v) {
      state.app_save_features_email = v;
    },
    set_app_update_deviceInfo(state, v) {
      state.deviceInfo.isMobileX = v.isMobileX;
      state.deviceInfo.isTabletX = v.isTabletX;
      state.deviceInfo.isDesktopX = v.isDesktopX;
    },
    store_previous_route(state, from) {
      // store the last 5 pages visited to allow the app
      // to select and prevent issue where some pages like
      // entering compare page with 3 plans redirects twice
      // and causes a single previous page store to fail
      // navigating back.
      state.previousRoute.push(from);
      if (state.previousRoute?.length > 5) {
        state.previousRoute = state.previousRoute.slice(
          state.previousRoute.length - 5,
          state.previousRoute.length
        );
      }
    },
    chatbot_push_watch_element(state, namedEle) {
      let found = false;
      state.chatbot_options.elements_to_watch.forEach((node) => {
        // to account for elements that may call lunaAttachElementWatch
        // multiple times by toggling the watched element multiple times
        if (node.name === namedEle.name) {
          found = true;
          return false;
        }
      });

      if (!found) state.chatbot_options.elements_to_watch.push(namedEle);
    },
    chatbot_detach_watch_element(state, name) {
      let detachIndex = state.chatbot_options.elements_to_watch.findIndex(
        (watchEle) => watchEle.name === name
      );

      if (detachIndex !== -1) {
        delete state.chatbot_options.elements_to_watch[detachIndex];
        state.chatbot_options.elements_to_watch =
          state.chatbot_options.elements_to_watch?.filter(
            (x) => x !== undefined
          );
      }
    },
    chatbot_call_adjust(state) {
      // change timestamp to when this mutation is called to trigger the computed
      // variable inside /components/global/LunaBoost to recompute the bottom position
      // based on the tallest "watched" element.
      state.chatbot_options.last_manual_adjust = new Date().getTime();
    },
    set_chatbotForcedRoute(state, value) {
      state.chatbotForcedRoute = value;
    },
    toggle_get_quote_btn(state, toggle) {
      // In order to reduce the strain on Vuex, only call this mutation
      // when actual value will be changing. This state is used as a signal
      // to toggle /layouts/Default/Header/Buttons/Buttons.vue -> Get Quotes
      // and to reduce the possibility of not breaking visibility of this
      // button due to not using scoped styling.
      // NOTE: Don't forget to call this mutation and setting the value to true
      // when navigating away from the component.
      // Ex: DestinationLanding::beforeDestroy();
      state.header_buttons_toggle.get_quotes = toggle;
    },
    toggle_my_policy_btn(state, toggle) {
      // In order to reduce the strain on Vuex, only call this mutation
      // when actual value will be changing. This state is used as a signal
      // to toggle /layouts/Default/Header/Buttons/Buttons.vue -> myPolicyText
      // and to reduce the possibility of not breaking visibility of this
      // button due to not using scoped styling.
      // NOTE: Don't forget to call this mutation and setting the value to true
      // when navigating away from the component.
      // Ex: DestinationLanding::beforeDestroy();
      state.header_buttons_toggle.my_policy = toggle;
    },
    set_chatBoxHideRoot(state, toggle) {
      state.chatBoxHideRoot = toggle;
    },
    reset_chatBoxHideRoot(state) {
      state.chatBoxHideRoot = false;
    },
    set_all_destinations_list(state, payload) {
      state.all_destinations_popup.destinations = payload;
    },
  },
  actions: {
    csis_state_update({ commit }, payload) {
      commit("set_csis_state", payload);
    },
    loading_update({ commit }, payload) {
      commit("loading_set", payload);
    },
    helper_props_update({ commit }, payload) {
      commit("helper_props_set", payload);
    },
    helper_comp_update({ commit }, payload) {
      commit("helper_comp_set", payload);
    },
    feature_flags_collect({ commit }) {
      return new Promise((resolve, reject) => {
        let url = "/features/";
        this._vm.$http
          .get(url)
          .then((res) => {
            if (res.data.features) {
              commit("feature_flags_set", res.data.features);
              commit("feature_flags_state_set", res.data.enabled);
              resolve(res.data.features);
            } else {
              reject("Invalid Response");
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    get_module_content({ _ }, slug) {
      return new Promise((resolve, reject) => {
        let url = `/article/module/${slug}/`;
        this._vm.$http
          .get(url)
          .then((res) => {
            if (res.data.module) {
              resolve(res.data.module);
            } else {
              reject("Invalid Response");
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    get_module_content_with_args({ _ }, { slug, args }) {
      return new Promise((resolve, reject) => {
        let url = `/article/module/${slug}/`;
        this._vm.$http
          .get(url, { params: args })
          .then((res) => {
            if (res.data.module) {
              resolve(res.data.module);
            } else {
              reject("Invalid Response");
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    get_app_config_data({ commit }, route) {
      var path = route.path;

      if (typeof VC_APP_CONFIG_VALUES === "undefined") {
        commit("set_main_config_failure", false);
        commit("set_main_config_data", null);
        commit("set_csis_state", null);
      }

      return new Promise((resolve, reject) => {
        let url = `/vue/config/default/?path=${path}`;
        if ("query" in route && Object.keys(route.query).length > 0) {
          Object.keys(route.query).forEach((k) => {
            url += `&${k}=${route.query[k]}`;
          });
        }

        this._vm.$http
          .get(url)
          .then((res) => {
            if (res.data.messages && res.data.messages.length > 0) {
              res.data.messages.forEach((m) => {
                m.dismissed = false;
              });
            }
            commit("set_main_config_data", res.data);
            commit("set_csis_state", res.data.csis);
            commit("app_features_set", res.data.features);
            resolve(res.data);
          })
          .catch((err) => {
            commit("set_main_config_failure", true);
            reject(err);
          });
      });
    },

    set_app_new_version_info({ commit }, value) {
      commit("app_new_version_info_set", value);
    },

    chatbotVisible_update({ commit }, visible) {
      commit("chatbotVisible_set", visible);
    },
    handleRouterURLQueries({ _ }, queryString) {
      return new Promise((resolve, reject) => {
        let url = `/vue/routerQueryHandler/?${queryString}`;
        this._vm.$http
          .get(url)
          .then((res) => {
            if (res.data) {
              resolve(res.data);
            } else {
              reject("Invalid Response");
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    set_app_features_list_items({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        if (
          !Object.keys(payload).includes("slug") ||
          !Object.keys(payload).includes("items")
        ) {
          reject("Invalid Payload");
        }
        if ("lists" in state.app_features) {
          let ss = Object.assign({}, state.app_features);
          let targetIndex = ss?.lists?.findIndex((x) => x.slug == payload.slug);
          if (!ss.lists[targetIndex]) {
            reject("Not Supported");
          }
          ss.lists[targetIndex].items = payload.items;
          commit("app_features_set", ss);
          resolve(ss);
        } else {
          reject("Not Supported");
        }
      });
    },
    set_save_plan_features_email({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        commit("app_save_features_email", payload);
        resolve(payload);
      });
    },
    feature_flag_usage_log({ _ }, payload) {
      return new Promise((resolve, reject) => {
        this._vm.$http
          .post(`/vue/featureFlagUsageLog/${payload.flag}/`, payload)
          .then((res) => {
            if (res.data) {
              resolve(res.data);
            } else {
              reject("Invalid Response");
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    force_update_main_config_data({ commit }, data) {
      commit("set_main_config_data", data);
      commit("set_csis_state", data.csis);
      commit("app_features_set", data.features);
    },
    update_device_info({ commit }, data) {
      commit("set_app_update_deviceInfo", data);
    },
    update_chatbotForcedRoute({ commit }, value) {
      commit("set_chatbotForcedRoute", value);
    },
    refresh_csis_status({ commit }) {
      return new Promise((resolve, reject) => {
        this._vm.$http
          .get("/csis/status/")
          .then((res) => {
            if (res.data?.success) {
              commit("set_csis_state", res.data);
              resolve(res.data);
            } else {
              reject("Invalid Response");
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    update_app_feature_varians({ commit }, data) {
      commit("app_features_variant_set", data);
    },
  },
};

export { globalModule };
